import GovGrButton from "../GovGrButton";
import { ACTIONS_FONT_SIZE } from "./constants";

const generateActions = (onEdit, onDelete, editLabel, deleteLabel) => {
  const actions = [];

  const editAction = {
    icon: () => (
      <GovGrButton
        style={{ fontSize: ACTIONS_FONT_SIZE }}
        variant="link"
        buttonText={editLabel}
      />
    ),
    onClick: onEdit,
  };

  const deleteAction = {
    icon: () => (
      <GovGrButton
        style={{ fontSize: ACTIONS_FONT_SIZE }}
        variant="link"
        buttonText={deleteLabel}
      />
    ),
    onClick: onDelete,
  };

  return [...actions, onEdit && editAction, onDelete && deleteAction];
};

export default generateActions;
